import React from 'react';
import { Link } from 'react-router-dom';

function ErrorPage() {
  return (
    <div className="error-container">
      <h1>Oops!</h1>
      <p>Something went wrong. The page you are looking for does not exist or an error occurred.</p>
      <Link to="/" className="home-link">Go to Home</Link>
    </div>
  );
}

export default ErrorPage;
